"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
/**
 * @internal
 * Call an editing callback with adding undo snapshots around, and trigger a ContentChanged event if change source is specified.
 * Undo snapshot will not be added if this call is nested inside another addUndoSnapshot() call.
 * @param core The EditorCore object
 * @param callback The editing callback, accepting current selection start and end position, returns an optional object used as the data field of ContentChangedEvent.
 * @param changeSource The ChangeSource string of ContentChangedEvent. @default ChangeSource.Format. Set to null to avoid triggering ContentChangedEvent
 * @param canUndoByBackspace True if this action can be undone when user press Backspace key (aka Auto Complete).
 */
exports.addUndoSnapshot = function (core, callback, changeSource, canUndoByBackspace) {
    var undoState = core.undo;
    var isNested = undoState.isNested;
    var isShadowEdit = !!core.lifecycle.shadowEditFragment;
    var data;
    if (!isNested) {
        undoState.isNested = true;
        if (!isShadowEdit) {
            undoState.snapshotsService.addSnapshot(core.api.getContent(core, 2 /* RawHTMLWithSelection */), canUndoByBackspace);
            undoState.hasNewContent = false;
        }
    }
    try {
        if (callback) {
            var range = core.api.getSelectionRange(core, true /*tryGetFromCache*/);
            data = callback(range && roosterjs_editor_dom_1.Position.getStart(range).normalize(), range && roosterjs_editor_dom_1.Position.getEnd(range).normalize());
            if (!isNested && !isShadowEdit) {
                undoState.snapshotsService.addSnapshot(core.api.getContent(core, 2 /* RawHTMLWithSelection */), false /*isAutoCompleteSnapshot*/);
                undoState.hasNewContent = false;
            }
        }
    }
    finally {
        if (!isNested) {
            undoState.isNested = false;
        }
    }
    if (callback && changeSource) {
        var event_1 = {
            eventType: 7 /* ContentChanged */,
            source: changeSource,
            data: data,
        };
        core.api.triggerEvent(core, event_1, true /*broadcast*/);
    }
    if (canUndoByBackspace) {
        var range = core.api.getSelectionRange(core, false /*tryGetFromCache*/);
        if (range) {
            core.undo.hasNewContent = false;
            core.undo.autoCompletePosition = roosterjs_editor_dom_1.Position.getStart(range);
        }
    }
};
//# sourceMappingURL=addUndoSnapshot.js.map